import { ISurvey } from '../../../../common/models/survey/ISurvey';
import { Routine } from 'redux-saga-routines';
import { fetchSurveysRoutine, markSurveyAsFavoriteRoutine, updateSurveyFilterRoutine } from '../../routines';
import { AssignmentFilterType } from '../../../../common/enums/AssignmentFilterType';
import { IFilter } from '../../../../common/models/filter/IFilter';

export type SurveyState = {
  surveys: ISurvey[];
  total: number;
  loading: boolean;
  assignmentFilter: AssignmentFilterType;
  filter: IFilter;
};

const initialState: SurveyState = {
  surveys: [],
  total: 0,
  loading: true,
  filter: {
    from: 0,
    to: 25,
    input: '',
    sort: [{ id: 'lastSendDate', desc: true }],
    filter: [],
    userIds: [],
    teamIds: []
  },
  assignmentFilter: AssignmentFilterType.ShowAll
};

export const surveys = (state: SurveyState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case fetchSurveysRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchSurveysRoutine.SUCCESS:
      const items = payload.reset ? payload.items : [...state.surveys, ...payload.items];
      return {
        ...state,
        surveys: items,
        total: payload.total,
        loading: false
      };
    case fetchSurveysRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case markSurveyAsFavoriteRoutine.SUCCESS:
      const { id, isFavorite } = payload;
      const surv = state.surveys.map(s => (s.id === id ? { ...s, isFavorite: !isFavorite } : s));
      return {
        ...state,
        surveys: surv
      };
    case updateSurveyFilterRoutine.TRIGGER: {
      const { filter, assignmentFilter } = payload;
      return {
        ...state,
        filter,
        assignmentFilter: assignmentFilter || state.assignmentFilter
      };
    }
    default:
      return state;
  }
};
